import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CreateOrUpdateCustomerNoteMutationVariables = Types.Exact<{
  customerId: Types.Scalars['Int']
  note: Types.Scalars['String']
}>

export type CreateOrUpdateCustomerNoteMutation = {
  __typename?: 'Mutation'
  createOrUpdateCustomerNote: boolean
}

export const CreateOrUpdateCustomerNoteDocument = gql`
  mutation CreateOrUpdateCustomerNote($customerId: Int!, $note: String!) {
    createOrUpdateCustomerNote(customerId: $customerId, note: $note)
  }
`
export type CreateOrUpdateCustomerNoteMutationFn = ApolloReactCommon.MutationFunction<
  CreateOrUpdateCustomerNoteMutation,
  CreateOrUpdateCustomerNoteMutationVariables
>
export function useCreateOrUpdateCustomerNoteMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateOrUpdateCustomerNoteMutation,
    CreateOrUpdateCustomerNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CreateOrUpdateCustomerNoteMutation,
    CreateOrUpdateCustomerNoteMutationVariables
  >(CreateOrUpdateCustomerNoteDocument, options)
}
export type CreateOrUpdateCustomerNoteMutationHookResult = ReturnType<
  typeof useCreateOrUpdateCustomerNoteMutation
>
export type CreateOrUpdateCustomerNoteMutationResult =
  ApolloReactCommon.MutationResult<CreateOrUpdateCustomerNoteMutation>
export type CreateOrUpdateCustomerNoteMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateOrUpdateCustomerNoteMutation,
  CreateOrUpdateCustomerNoteMutationVariables
>
